/*
    © 2022 KondaSoft.com
    https://www.kondasoft.com
*/

// Ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async (form, event) => {
  event.preventDefault();

  const btn = form.querySelector('button[name="add"]');
  const idValue = form.querySelector('input[name="id"]')?.value;
  const chosen = (typeof product !== 'undefined' && product.variants || [])
    .find(v => String(v.id) === String(idValue));
  if (!chosen || !chosen.available) return;
  btn.classList.add("loading");
  const formData = new FormData(form);

  let cartData = {
    items: [
      {
        id: parseInt(formData.get("id")),
        quantity: 1,
      },
    ],
  };

  const addSecondProductCheckbox = document.querySelector(
    "input[name=add_second_product]"
  );
  const secondProductId = document.querySelector(
    "input[name=second_product_id]"
  );
  const addSecondProduct =
    addSecondProductCheckbox &&
    addSecondProductCheckbox.checked &&
    secondProductId.dataset.available === "true";

  // tagging second product to main product so we can remove second product with main product
  if (addSecondProduct) {
    cartData.items[0] = {
      ...cartData.items[0],
      properties: {
        _second_product_id: secondProductId.value,
      },
    };
  }

  if (addSecondProduct) {
    let secondProductId = parseInt(formData.get("second_product_id"));

    cartData.items.push({
      id: secondProductId,
      quantity: 1,
      properties: {
        _disable_quantity_edit: true,
      },
    });
  }

  const addonProducts = document.querySelectorAll(".addon-product");

  addonProducts.forEach((addonProduct) => {
    const addAddonCheckbox = addonProduct.querySelector(
      "input[name=add_addon]"
    );
    if (addAddonCheckbox.checked) {
      let productId = parseInt(addonProduct.dataset.id);
      cartData.items.push({
        id: productId,
        quantity: 1,
      });
    }
  });

  // putting items in order
  cartData.items = cartData.items.reverse();

  await fetch("/cart/add.js", {
    method: "POST",
    body: JSON.stringify(cartData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  btn.classList.remove("loading");

  if (document.querySelector("#offcanvas-cart")) {
    bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart").show();
  }

  window.refreshCartContents();
};

window.updateAddonVariant = function(selectElement) {
  const variantId = selectElement.value;
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const price = selectElement.options[selectElement.selectedIndex].dataset.price;
  const imageUrl = selectedOption.dataset.imageUrl;

  // Update the parent label data-id attribute
  const addonProductLabel = selectElement.closest('.addon-product');
  addonProductLabel.dataset.id = variantId;

  // Update checkbox value and data-product-price
  const checkbox = addonProductLabel.querySelector('input[name="add_addon"]');
  checkbox.value = variantId;
  checkbox.dataset.productPrice = price;

  // Update displayed price
  const priceDisplay = addonProductLabel.querySelector('.product-price');
  priceDisplay.innerHTML = window.formatMoney(price);

  // Update product image if we have an image URL
  if (imageUrl) {
    const productImage = addonProductLabel.querySelector('img.thumbnail');
    if (productImage) {
      productImage.src = imageUrl;
    }
  }

  // Ensure the selected class is applied correctly
  if (checkbox.checked) {
    addonProductLabel.classList.add('selected');
    updateAddToCartTotalPrice();
  } else {
    addonProductLabel.classList.remove('selected');
  }
}

window.updateAddToCartTotalPrice = () => {
  let productPrices = [];

  // main product price
  productPrices.push(parseInt(getSelectedVariantPrice()));

  // second product price if checked
  if (document.querySelector("#add_second_product:checked")) {
    let secondProductSelect = document.querySelector("#second-product");
    let secondProductPrice =
      secondProductSelect.options[secondProductSelect.selectedIndex].dataset
        .productPrice;
    productPrices.push(parseInt(secondProductPrice));
  }

  // any addon product prices that are checked
  [
    ...document.querySelectorAll(
      ".addon-product input[name=add_addon]:checked"
    ),
  ].map((element) =>
    productPrices.push(parseInt(element.dataset.productPrice))
  );

  const sum = productPrices.reduce((partialSum, a) => partialSum + a, 0);

  const button = document.querySelector('button.btn-atc');
  if (button && !button.disabled) button.innerHTML = `ADD TO CART&nbsp;-&nbsp;${formatMoney(sum)}`;
};

const initBubbleOptions = function () {
  const bubbleOptionsList = document.querySelectorAll(".bubble-options");

  bubbleOptionsList.forEach((bubbleOptions) => {
    if (bubbleOptions) {
      const bubbleOptionsLabels = bubbleOptions.querySelectorAll("label");
      const bubbleOptionsInputs = bubbleOptions.querySelectorAll("input");

      const resetLabels = (bubbleOptionsLabels) => {
        bubbleOptionsLabels.forEach((label) => {
          if (label.classList.contains("selected")) {
            label.classList.remove("selected");
          }
        });
      };

      bubbleOptionsInputs.forEach((input) => {
        input.addEventListener("change", (e) => {
          resetLabels(bubbleOptionsLabels);

          // console.log(`e.target`, e.target);
          if (e.target.checked) {
            e.target.parentElement.classList.add("selected");
          }
        });
      });
    }
  });
};

initBubbleOptions();

/*
    This function updates the product option select element
    based on the selected value of the bubble element.
*/
function updateProductOptionSelect(input) {
  const bubbleElementValue = input.value;
  const productOptionSelectElement = document.querySelector(
    ".product-option-select select"
  );
  const optionsElements = productOptionSelectElement.querySelectorAll("option");

  if (optionsElements) {
    // setting display visible or none
    optionsElements.forEach((element) => {
      if (element.dataset.productOption1Value == bubbleElementValue) {
        element.style.display = "";
      } else {
        element.style.display = "none";
      }
    });

    // making select updates to display correct item
    for (var i = 0; i < optionsElements.length; i++) {
      if (optionsElements[i].style.display !== "none") {
        productOptionSelectElement.selectedIndex = i;
        break;
      }
    }
  }
}

// Native variant options: distinguish nonexistent combinations from sold-out ones.
function koreOptionGroups(wrapper) {
  return [...wrapper.querySelectorAll('.product-options > li')].map((li, index) => ({
    index, li, controls: [...li.querySelectorAll('.product-option')],
    isSwatch: !!li.querySelector('.product-color-slider')
  })).filter(group => group.controls.length);
}

function koreSelectedValue(group) {
  const select = group.controls.find(el => el.tagName === 'SELECT');
  if (select) return select.value || null;
  return group.controls.find(el => el.checked)?.value || null;
}

function koreClearGroup(group) {
  group.controls.forEach(el => { if (el.type === 'radio') el.checked = false; });
  const select = group.controls.find(el => el.tagName === 'SELECT');
  if (select) select.value = '';
}

// Keep the size option ready so customers can browse color swatches immediately.
// Only actual Size options are defaulted; Select Strap and all other choices remain blank.
function koreDefaultSize(wrapper) {
  const variants = (typeof product !== 'undefined' && product.variants) || [];
  const groups = koreOptionGroups(wrapper);
  const sizeGroup = groups.find(group => {
    const label = group.li.querySelector('.product-option-name');
    const optionName = group.controls[0]?.getAttribute('name') ||
      (label?.textContent || '').replace(/^\s*Select\s+/i, '').trim();
    return /^(size|belt size|waist size)$/i.test(optionName.trim());
  });
  if (!sizeGroup || koreSelectedValue(sizeGroup)) return;
  const candidates = sizeGroup.controls.filter(control => control.value);
  const otherChoices = groups.filter(group => group.index !== sizeGroup.index && koreSelectedValue(group));
  const matching = (control, availableOnly) => variants.some(variant =>
    (!availableOnly || variant.available) &&
    variant.options[sizeGroup.index] === control.value &&
    otherChoices.every(group => variant.options[group.index] === koreSelectedValue(group)));
  const choice = candidates.find(control => matching(control, true)) ||
    candidates.find(control => matching(control, false));
  if (!choice) return;
  if (choice.tagName === 'SELECT') choice.value = choice.value;
  else choice.checked = true;
}

function koreRefreshOptionUI(wrapper, changedIndex = -1) {
  const variants = (typeof product !== 'undefined' && product.variants) || [];
  const groups = koreOptionGroups(wrapper);
  if (!variants.length || !groups.length) return null;

  let selected = groups.map(koreSelectedValue);
  // The option just chosen wins. If another previous choice cannot coexist,
  // clear that previous choice rather than silently choosing a different value.
  if (changedIndex >= 0) {
    for (const group of groups) {
      if (group.index === changedIndex || !selected[group.index]) continue;
      const compatible = variants.some(v =>
        v.options[changedIndex] === selected[changedIndex] &&
        v.options[group.index] === selected[group.index]);
      if (!compatible) { koreClearGroup(group); selected[group.index] = null; }
    }
  }

  groups.forEach(group => {
    const otherChoices = groups.filter(g => g.index !== group.index && selected[g.index]);
    group.controls.forEach(control => {
      if (control.tagName === 'SELECT') {
        [...control.options].forEach(option => {
          if (!option.value) return;
          const matches = variants.filter(v =>
            v.options[group.index] === option.value &&
            otherChoices.every(g => v.options[g.index] === selected[g.index]));
          const nonexistent = matches.length === 0;
          const soldOut = !nonexistent && matches.every(v => !v.available);
          option.hidden = nonexistent;
          option.disabled = nonexistent;
          option.textContent = option.dataset.koreOriginalLabel || option.textContent;
          option.dataset.koreOriginalLabel = option.textContent;
          if (soldOut) option.textContent += ' - Sold out';
        });
        return;
      }
      const matches = variants.filter(v =>
        v.options[group.index] === control.value &&
        otherChoices.every(g => v.options[g.index] === selected[g.index]));
      const nonexistent = matches.length === 0;
      const soldOut = !nonexistent && matches.every(v => !v.available);
      const label = control.closest('label');
      const slide = control.closest('.swiper-slide');
      if (label) {
        label.classList.toggle('kore-option-sold-out', soldOut);
        label.classList.toggle('kore-option-nonexistent', nonexistent);
        label.setAttribute('aria-label', control.value + (soldOut ? ' - Sold out' : ''));
      }
      if (slide) slide.classList.toggle('kore-option-hidden', nonexistent);
      else if (label) label.classList.toggle('kore-option-hidden', nonexistent);
      // Sold-out variants must remain enabled for Notify Me integrations.
      control.disabled = nonexistent;
    });
    group.li.querySelectorAll('.bubble-options label').forEach(label =>
      label.classList.toggle('selected', !!label.querySelector('input:checked')));
    const selectedText = group.li.querySelector('.selected-option-text');
    if (selectedText) selectedText.textContent = koreSelectedValue(group) || '';
    const swatchSwiper = group.li.querySelector('.product-color-slider')?.swiper;
    if (swatchSwiper) swatchSwiper.update();
  });

  const complete = selected.length === groups.length && selected.every(Boolean);
  return complete ? variants.find(v => v.options.length === selected.length &&
    v.options.every((value, index) => value === selected[index])) || null : null;
}

function koreApplyVariant(wrapper, variant) {
  const idField = wrapper.querySelector('form input[name="id"]');
  if (idField) idField.value = variant ? variant.id : '';
  const addButton = wrapper.querySelector('button[name="add"]');
  if (addButton) {
    addButton.disabled = !variant || !variant.available;
    if (!variant) addButton.textContent = 'SELECT OPTIONS';
    else if (!variant.available) addButton.textContent = 'SOLD OUT';
  }
  const error = wrapper.querySelector('.product-error');
  if (error) {
    error.textContent = variant && !variant.available ? 'Selected product is sold out.' : '';
    error.style.display = variant && !variant.available ? 'block' : 'none';
  }
  if (variant) {
    const finalPrice = wrapper.querySelector('.product-price-final');
    const compareWrap = wrapper.querySelector('.product-price-compare');
    if (finalPrice) finalPrice.innerHTML = window.formatMoney(variant.price);
    if (compareWrap) {
      const discounted = variant.compare_at_price && variant.price < variant.compare_at_price;
      compareWrap.style.display = discounted ? 'inline-block' : 'none';
      const amount = compareWrap.querySelector('s');
      if (amount) amount.innerHTML = discounted ? window.formatMoney(variant.compare_at_price) : '';
    }
    const sku = wrapper.querySelector('[data-variant-sku]');
    if (sku) { sku.textContent = variant.sku ? 'SKU: ' + variant.sku : ''; sku.style.display = variant.sku ? '' : 'none'; }
  }
  const url = new URL(window.location.href);
  if (variant) url.searchParams.set('variant', variant.id);
  else url.searchParams.delete('variant');
  window.history.replaceState(window.history.state, '', url);
  document.dispatchEvent(new CustomEvent('kore:variant:change', { detail: { variant, product: wrapper } }));
  // Notify Me apps commonly observe changes to the hidden Shopify variant input.
  if (idField) idField.dispatchEvent(new Event('change', { bubbles: true }));
  if (variant && variant.available && typeof window.updateAddToCartTotalPrice === 'function') {
    window.updateAddToCartTotalPrice();
  }
}

window.onChangeProductOption = (input) => {
  const wrapper = input.closest('#template-product');
  if (!wrapper) return;
  const groups = koreOptionGroups(wrapper);
  const changed = groups.find(g => g.controls.includes(input));
  // A newly selected swatch can invalidate the default size. Pick the first
  // compatible size rather than leaving size empty or undoing the swatch.
  const variantBeforeSize = koreRefreshOptionUI(wrapper, changed ? changed.index : -1);
  koreDefaultSize(wrapper);
  const variant = koreRefreshOptionUI(wrapper);
  koreApplyVariant(wrapper, variant || variantBeforeSize);
};

function koreInitializeProductOptions() {
  const wrapper = document.querySelector('#template-product');
  if (!wrapper) return;
  if (!wrapper.querySelector('.product-options')) return;
  const variants = (typeof product !== 'undefined' && product.variants) || [];
  const linkedId = new URL(window.location.href).searchParams.get('variant');
  const linkedVariant = variants.find(v => String(v.id) === String(linkedId));
  const groups = koreOptionGroups(wrapper);
  groups.forEach(group => {
    if (linkedVariant) {
      const desired = linkedVariant.options[group.index];
      const select = group.controls.find(el => el.tagName === 'SELECT');
      if (select) select.value = desired;
      else group.controls.forEach(el => { el.checked = el.value === desired; });
    } else koreClearGroup(group);
  });
  if (!linkedVariant) koreDefaultSize(wrapper);
  const variant = koreRefreshOptionUI(wrapper);
  koreApplyVariant(wrapper, variant);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', koreInitializeProductOptions);
} else koreInitializeProductOptions();
window.addEventListener('popstate', koreInitializeProductOptions);

window.onChangeSecondProductCheckbox = async (input) => {
  const secondProductActive = input.checked;
  const secondProductCol = document.querySelector(".second-product-options");
  if (!secondProductCol) return;

  if (secondProductActive) {
    if (secondProductCol.classList.contains("active") == false) {
      secondProductCol.classList.add("active");
    }
  } else {
    if (secondProductCol.classList.contains("active")) {
      secondProductCol.classList.remove("active");
    }
  }
};

// Product Options - listen for onchange events
window.onChangeSecondStrapSwatch = (input) => {
  if (!input.checked) return;
  const secondProductSelect = document.querySelector('#second-product');
  if (!secondProductSelect) return;
  secondProductSelect.value = input.value;
  // Preserve the existing select-based variant and total-price update pathway.
  secondProductSelect.dispatchEvent(new Event('change', { bubbles: true }));
};

window.onChangeSecondProductOption = (input) => {
  const productWrapper = input.closest('.product');
  if (!productWrapper) return;
  const selectedOption = input.options[input.selectedIndex];
  if (!selectedOption) return;
  const secondProductId = productWrapper.querySelector('[name="second_product_id"]');
  if (secondProductId) {
    secondProductId.value = input.value;
    secondProductId.dataset.available = 'true';
  }
  productWrapper.querySelectorAll('input[name="second_strap_swatch"]').forEach(swatch => {
    swatch.checked = swatch.value === input.value;
  });
  // Do not change the main product's ?variant= URL parameter.
  // Optional price elements are updated only if present in the theme.
  const price = Number(selectedOption.dataset.productPrice);
  const finalPrice = productWrapper.querySelector('.second-product-price-final');
  if (finalPrice && Number.isFinite(price)) finalPrice.innerHTML = window.formatMoney(price);
  const compareWrap = productWrapper.querySelector('.second-product-price-compare');
  if (compareWrap) compareWrap.style.display = 'none';
  if (typeof window.updateAddToCartTotalPrice === 'function') window.updateAddToCartTotalPrice();
};

// 'Buy it now' buttons
window.onClickBuyBtn = (btn) => {
  btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `;
  const form = btn.closest("form");
  const variantId = form.querySelector('[name="id"]').value;
  const qty = Number(form.querySelector('input[name="quantity"]').value || 1);
  window.location.href = `/cart/${variantId}:${qty}`;
};

// Product Carousel - Sticky position on scroll (only desktop)
const productCarousel = document.querySelector("#product-carousel.sticky-top");
if (productCarousel) {
  const navbarHeight =
    document.querySelector("#shopify-section-navbar.sticky-top").clientHeight ||
    0;
  productCarousel.style.top = `${navbarHeight + 20}px`;
  productCarousel.style.zIndex = "1";
}

// Native swatch test: preserve all option values; selected variant determines availability.

function getProductDataByProductOption(product) {
  // Create an empty object to store the new structure
  var newObject = [];

  // Loop through each option of the product
  product.options.forEach(function (option, optionIndex) {
    // Create a new object for the option
    var optionObject = {
      name: option,
      values: {},
    };

    // Loop through each value of the option
    product.variants.forEach(function (variant, variantIndex) {
      // Get the value of the current option for this variant
      var optionValue = variant.options[optionIndex];

      // Check if this value already exists in the optionObject
      if (optionObject.values.hasOwnProperty(optionValue)) {
        // If it does, push the variant to the existing array
        optionObject.values[optionValue].push(variant);
      } else {
        // If it doesn't, create a new array with the variant and add it to the values object
        optionObject.values[optionValue] = [variant];
      }
    });

    // Add the optionObject to the newObject with the option name as the key
    newObject.push(optionObject);
  });

  // Output the new object
  return newObject;
}

/**
 * Returns an array of the values of all checked input elements in the given array.
 *
 * @param {HTMLInputElement[]} inputs - An array of input elements.
 * @returns {string[]} An array of the values of all checked input elements in the given
 * @throws {TypeError} If the 'inputs' parameter is not an array-like object or is not defined.
 */
function getSelectedInputs(inputs) {
  if (!inputs || typeof inputs !== "object" || !inputs.length) {
    throw new TypeError(
      "The 'inputs' parameter must be an array-like object and cannot be undefined."
    );
  }

  var selectedInputs = [];
  for (var i = 0; i < inputs.length; i++) {
    if (inputs[i].checked) {
      selectedInputs.push(inputs[i].value);
    }
  }

  return selectedInputs;
}

function setProductColorOptionAvailability() {
  const checkedProductBubbleOption = document.querySelector(
    ".bubble-options input.product-option:checked"
  );
  const productColorSliderElement = document.querySelector(
    ".product-color-slider"
  );
  const sliderProductOptionLabels =
    productColorSliderElement.querySelectorAll("label");

  const variantOptions = {};
  product.variants.forEach((variant) => {
    const option0 = variant.options[0];
    const option1 = variant.options[1];
    if (!variantOptions[option0]) {
      variantOptions[option0] = {};
    }
    variantOptions[option0][option1] = variant.available;

    // if we have bubble options first, use them, otherwise go to next options available
    if (option0 && option1) {
      if (!variantOptions[option0]) {
        variantOptions[option0] = {};
      }
      variantOptions[option0][option1] = variant.available;
    } else if (option0) {
      if (!variantOptions[option0]) {
        variantOptions[option0] = {};
      }
      variantOptions[option0] = variant.available;
    }
  });

  sliderProductOptionLabels.forEach((label) => {
    let input = label.querySelector("input");

    // if we have bubble options first, use them, otherwise go to next options available
    if (
      checkedProductBubbleOption &&
      checkedProductBubbleOption.value &&
      input.value
    ) {
      let option0 = checkedProductBubbleOption.value;
      let option1 = input.value;

      if (variantOptions[option0] && variantOptions[option0][option1]) {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    } else if (input.value) {
      let option1 = input.value;

      if (variantOptions[option1]) {
        input.disabled = false;
      } else {
        input.disabled = true;
      }
    }
  });
}

function getSelectedOptions() {
  const inputs = document.getElementsByClassName("product-option");
  const selectedOptions = [];

  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];

    // Check if the input is checked (for checkboxes and radio buttons)
    if (input.type === "checkbox" || input.type === "radio") {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    }
    // For other input types, like select or text, just push the value
    else {
      selectedOptions.push(input.value);
    }
  }

  return selectedOptions;
}

function findVariantByOptions(options) {
  const { variants } = product;

  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    const variantOptions = variant.options;

    if (options.every((option, index) => option === variantOptions[index])) {
      return variant;
    }
  }

  return null;
}

function getSelectedVariantPrice() {
  const selectedId = document.querySelector('#template-product form input[name="id"]')?.value;
  const selected = (typeof product !== 'undefined' && product.variants || []).find(v => String(v.id) === String(selectedId));
  return selected ? selected.price : 0;
}

function hasParentWithClass(element, className) {
  let parent = element.parentElement;

  while (parent) {
    if (parent.classList.contains(className)) {
      return true;
    }
    parent = parent.parentElement;
  }

  return false;
}